import React, { useMemo } from 'react'

import {
  Icon,
  Tag,
  TagCloseButton,
  TagLabel,
  Tooltip,
  Wrap,
  WrapItem,
} from '@chakra-ui/react'
import { useField } from 'formik'
import { StarIcon } from 'lucide-react'

import BaseArrayField from './BaseArrayField'
import { LanguageSelect } from '../../../../ui/select'

const LanguagesField = ({ field = 'languages' }) => {
  const [formikField, , helpers] = useField(field)

  const { value: languages } = formikField
  const { setValue } = helpers
  const selectedLanguages = useMemo(
    () => languages?.map(language => ({ label: language, value: language })),
    [languages]
  )

  const setPreferredLanguage = index => {
    if (!languages || languages.length === 0) return
    if (index < 0 || index >= languages.length) return

    const newLanguages = [
      languages[index],
      ...languages.slice(0, index),
      ...languages.slice(index + 1),
    ]

    setValue(newLanguages)
  }

  const removeLanguage = index => {
    if (!languages || languages.length === 0) return
    if (index < 0 || index >= languages.length) return

    setValue(languages.filter((_, i) => i !== index))
  }

  return (
    <BaseArrayField label='Languages' field={field}>
      {({ onSelect, onRemove, onClear }) => (
        <>
          <LanguageSelect
            onSelect={onSelect}
            onRemove={onRemove}
            onClear={onClear}
            initialSelected={selectedLanguages}
            dropdownHeight={150}
            inputProps={{
              id: 'language-select',
            }}
            showTags={false}
          />
          <Wrap mt={2}>
            {languages?.map((language, index) => (
              <WrapItem key={language}>
                {index === 0 ? (
                  <Tooltip label='Preferred language'>
                    <Tag colorScheme='yellow'>
                      <TagLabel userSelect='none'>{language}</TagLabel>
                      <TagCloseButton onClick={() => removeLanguage(index)} />
                    </Tag>
                  </Tooltip>
                ) : (
                  <Tag>
                    <TagLabel userSelect='none'>{language}</TagLabel>
                    <Tooltip label='Set as preferred language'>
                      <Icon
                        as={StarIcon}
                        cursor='pointer'
                        pl={1}
                        onClick={() => setPreferredLanguage(index)}
                      />
                    </Tooltip>
                    <TagCloseButton onClick={() => removeLanguage(index)} />
                  </Tag>
                )}
              </WrapItem>
            ))}
          </Wrap>
        </>
      )}
    </BaseArrayField>
  )
}

export default LanguagesField
